module.exports = __webpack_public_path__ + "media/images/icon-arrow-ur@3x-fa66d28592ecae5a113f6fec8be549a1.png";